import { GRID_COLUMNS_CLASS } from "src/flowsOverview/FlowOverview";

export const Separator: React.FC = () => (
  <div className={`mb-10 ${GRID_COLUMNS_CLASS}`}>
    <hr className="col-span-full border-t-gray-200" />
  </div>
);
